import { useQuery } from '@tanstack/react-query';
import { fetchActiveSession } from '../api/activeSessionApi';

export const activeSessionKeys = {
  all: ['active-session'] as const,
};

export function useActiveSession(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: activeSessionKeys.all,
    queryFn: fetchActiveSession,
    staleTime: 60 * 1000,
    enabled: options?.enabled ?? true,
  });
}
